import React from "react";

const multiSelectQuestionIcon = (
  <svg
    width="36"
    height="36"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="17"
      height="17"
      rx="3.5"
      fill="white"
      stroke="#6A7F87"
    />
    <rect
      x="2.11768"
      y="2.11765"
      width="13.7647"
      height="13.7647"
      rx="2"
      fill="#E8ECED"
    />
    <path
      d="M12.4342 6.76946L7.84598 11.7106C7.77946 11.7824 7.68615 11.8233 7.58833 11.8236C7.49452 11.8241 7.40435 11.7873 7.33774 11.7212L5.57304 9.95652C5.43464 9.81813 5.43464 9.59374 5.57304 9.45535C5.71143 9.31695 5.93582 9.31695 6.07421 9.45535L7.58833 10.9624L11.9189 6.28946C12.002 6.18703 12.1352 6.13945 12.2644 6.1661C12.3935 6.19275 12.4971 6.28918 12.5328 6.41613C12.5685 6.54308 12.5305 6.67935 12.4342 6.76946Z"
      fill="#6A7F87"
      stroke="#6A7F87"
    />
  </svg>
);

export default multiSelectQuestionIcon;
